import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import DeleteAllCardsModal from './Modals/DeleteAllCardsModal/DeleteAllCardsModal.js';
import DeleteCardModal from './Modals/DeleteCardModal/DeleteCardModal.js';
import DeleteCardModalNew from './Modals/DeleteCardModalNew/DeleteCardModalNew.js';
import NewCardModal from './Modals/NewCardModal/NewCardModal.js';

const Overlays = ({ containerType, customerType, currency, customerId, sid, siteId, }) => {
    return (jsxs(Fragment, { children: [jsx(NewCardModal, { containerType: containerType, customerType: customerType, currency: currency, customerId: customerId, sid: sid, siteId: siteId }), jsx(DeleteAllCardsModal, {}), jsx(DeleteCardModal, {}), jsx(DeleteCardModalNew, {})] }));
};

export { Overlays as default };
//# sourceMappingURL=index.js.map
